module.exports = __webpack_public_path__ + "img/menu-right-accent-1.d8588b9c.svg";